import { useState } from "react";
import {
  Box,
  Button,
  List,
  Divider,
  Grid2,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";


import { useDispatch, useSelector } from "react-redux";
import { removeProperty } from "../redux/userSlice";
import PropertyListItem from "./PropertyListItem";
import PropertiesDialog from "./PropertyDialog";
import { PropertiesAPI } from "../apis/propertiesAPI";


const PropertiesView = () => {
  const dispatch = useDispatch();
  const [propertyToDelete, setPropertyToDelete] = useState({} as any);
  const properties = useSelector((state: any) => state.user.properties);

  const [creatingProperty, setCreatingProperty] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);

  const deleteProperty = async (id: string) => {
    try {
      await PropertiesAPI.deleteProperty(id);
      dispatch(removeProperty({ id }));
    } catch (error) {
      console.log("error deleting", error);
    }
  };

  const propertiesContent = (
    <List
      sx={{
        width: "100%",
        bgcolor: "background.paper",
        border: "1px none red",
      }}
    >
      {properties.map((p: any, i: number) => (
        <div>
          <PropertyListItem
            property={p}
            onSelect={() => {
              setSelectedProperty(p);
              setCreatingProperty(true);
            }}
            onDelete={() => {
              setPropertyToDelete(p);
            }}
          />

          {i !== properties.length - 1 ? (
            <Divider variant="inset" component="li" />
          ) : null}
        </div>
      ))}
    </List>
  );

  const noPropertiesContent = <Box>You have no properties right now.</Box>;

  return (
    <>
      <Dialog open={propertyToDelete.id}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          
          {/* This action will delete {addressToString(propertyToDelete.address)} */}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={() => {
            deleteProperty(propertyToDelete.id);
            setPropertyToDelete({} as any);
          }}>Yes</Button>
          <Button>no</Button>
        </DialogActions>
      </Dialog>
      <PropertiesDialog
        open={creatingProperty}
        handleClose={() => {
          setCreatingProperty(false);
        }}
        property={selectedProperty || {}}
      />
      <Grid2 container sx={{ margin: "1rem" }}>
        <Grid2 size={12}>
          <Box
            sx={{
              flexGrow: 1,
              border: "1px none green",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              style={{
                width: "10rem",
                borderRadius: "1.25rem",
                fontFamily: "Arial",
              }}
              onClick={() => {
                setSelectedProperty(null);
                setCreatingProperty(true)
              }}
            >
              Add Property
            </Button>
          </Box>
        </Grid2>
        <Grid2
          size={12}
          sx={{ display: "flex", justifyContent: "left", paddingTop: "3rem" }}
        >
          {properties.length > 0 ? "Your properties" : null}
        </Grid2>

        <Grid2 size={12} sx={{ width: "100%", border: "1px none green" }}>
          {properties.length > 0 ? propertiesContent : noPropertiesContent}
        </Grid2>
      </Grid2>
    </>
  );
};

export default PropertiesView;
